import { FileText, X } from "lucide-react";
import type { Attachment, Offer } from "../../../domain/request-detail-types";

type Props = {
 previewAttachment: Attachment | null; previewObjectUrl: string; previewError: string;
 setPreviewAttachment: (attachment: Attachment | null) => void;
 getAttachmentOffer: (attachment: Attachment) => Offer | null;
};
export function RequestAttachmentPreview({previewAttachment, previewObjectUrl, previewError, setPreviewAttachment, getAttachmentOffer}: Props) {
 return previewAttachment ? (
        <div
          className="attachment-preview-backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget)
              setPreviewAttachment(null);
          }}
        >
          <section
            className="attachment-preview-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="attachment-preview-title"
          >
            <header>
              <div>
                <small>
                  {getAttachmentOffer(previewAttachment)
                    ? `Teklif belgesi · ${
                        getAttachmentOffer(previewAttachment)?.supplier
                      } · ${getAttachmentOffer(previewAttachment)?.offer_no}`
                    : "Genel talep belgesi"}
                </small>
                <strong id="attachment-preview-title">
                  {previewAttachment.original_name}
                </strong>
              </div>
              <button
                type="button"
                aria-label="Belge önizlemesini kapat"
                onClick={() => setPreviewAttachment(null)}
                autoFocus
              >
                <X size={20} aria-hidden="true" />
              </button>
            </header>
            <div className="attachment-preview-content">
              {previewError ? (
                <div className="attachment-preview-error" role="alert">
                  <FileText size={28} aria-hidden="true" />
                  <strong>Belge açılamadı</strong>
                  <p>{previewError}</p>
                </div>
              ) : !previewObjectUrl ? (
                <div className="attachment-preview-loading" role="status">
                  Belge hazırlanıyor…
                </div>
              ) : previewAttachment.content_type.startsWith("image/") ? (
                <img
                  src={previewObjectUrl}
                  alt={previewAttachment.original_name}
                />
              ) : (
                <iframe
                  src={previewObjectUrl}
                  title={previewAttachment.original_name}
                />
              )}
            </div>
          </section>
        </div>
      ) : null;
}
